<template>
  <div class="card height-100" id="honoraire">
    <header class="header-card">
      <p>
        {{ $t('editionClient.generalTitle.honoraire')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-8">
          <b-field :label="$t('editionClient.honoraire.modeCalcul')">
            <div class="mgt-10px">
              <div v-if="tiers.modeCalculHonoraire.modeCalcul === constantes.MODE_CALCUL_FORFAIT"
                   class="has-text-default">
                <span class="is-italic">
                  {{ $t('editionClient.honoraire.forfait') }}
                </span>
                <span class="has-text-weight-bold">
                 {{ Number(tiers.modeCalculHonoraire.montantForfaitHt) | formatDevise }}
              </span>
              </div>
              <div v-if="tiers.modeCalculHonoraire.modeCalcul === constantes.MODE_CALCUL_MANUEL"
                   class="has-text-weight-bold has-text-default">
                {{ $t('editionClient.honoraire.manuel') }}
              </div>
              <div v-if="tiers.modeCalculHonoraire.modeCalcul
              === constantes.MODE_CALCUL_POURCENTAGE"
                   class="has-text-default">
                <div class="mgb-8px">
                  <span class="is-italic">
                    {{ $t('editionClient.honoraire.pourcentage') }}
                  </span>
                  <span class="has-text-weight-bold">
                 {{ tiers.modeCalculHonoraire.pourcentage }} %
                </span>
                </div>
                <div>
                  <span class="is-italic">
                    {{ $t('editionClient.honoraire.pourcentageApply') }}
                  </span>
                  <span class="has-text-weight-bold">
                 {{ getPourcentageApply }}
                </span>
                </div>
              </div>
            </div>
          </b-field>
        </div>
        <div class="column is-4 has-text-right" v-if="isEdit">
          <qd-button class="is-primary" @click="openPopUpModeCalcul = true">
            {{$t('general.button.edit')}}
          </qd-button>
        </div>
        <div class="column is-12 has-text-default">
          <b-field :label="$t('editionClient.honoraire.commentaire')"
                   custom-class="has-text-weight-normal is-italic">
            <div class="has-text-weight-bold">
              {{ tiers.modeCalculHonoraire.commentaire }}
            </div>
          </b-field>
        </div>
      </div>
    </div>
    <b-modal v-model="openPopUpModeCalcul"
             v-if="isEdit"
             has-modal-card
             width="700px"
             class="modal">
      <pop-up-honoraire :mode-calcul-honoraire="tiers.modeCalculHonoraire"
                        @updateModeCalculHonoraire="tiers.modeCalculHonoraire = $event">
      </pop-up-honoraire>
    </b-modal>
  </div>
</template>

<script>

import {
  MODE_CALCUL_MANUEL,
  MODE_CALCUL_FORFAIT,
  MODE_CALCUL_POURCENTAGE,
} from '@/configuration/tiers/tiersConf';
import popUpHonoraire from '@/components/clients/clients/editionClient/honoraire/p_honoraire';

export default {
  name: 'ClientHonoraire',
  props: {
    tiers: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      openPopUpModeCalcul: false,
      constantes: {
        MODE_CALCUL_POURCENTAGE,
        MODE_CALCUL_MANUEL,
        MODE_CALCUL_FORFAIT,
      },
    };
  },
  components: {
    popUpHonoraire,
  },
  computed: {
    getPourcentageApply() {
      let pourcentageAply = '';
      if (this.tiers.modeCalculHonoraire.applicableSurLocation) {
        pourcentageAply += this.$i18n.t('editionClient.honoraire.loc') + (this.tiers.modeCalculHonoraire.applicableSurTlpe ? ', ' : '');
      }
      if (this.tiers.modeCalculHonoraire.applicableSurTlpe) {
        pourcentageAply += this.$i18n.t('editionClient.honoraire.tlpe');
      }
      return pourcentageAply;
    },
  },
};
</script>
